var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-inlinemenu"},[_c('div',{staticClass:"activator"},[_vm._t("activator")],2),_c('div',{staticClass:"content",class:_vm.contentClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }